import { createUserOnboardingCompletionMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserOnboardingCompletionMutation = createUserOnboardingCompletionMutation(HTTP_CONFIG.API.Consumer.url)
